'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _capitalize = require('../../utils/capitalize');

var _capitalize2 = _interopRequireDefault(_capitalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Grid = function Grid(_ref) {
    var _classnames;

    var className = _ref.className,
        align = _ref.align,
        noWrap = _ref.noWrap,
        sNoWrap = _ref.sNoWrap,
        mNoWrap = _ref.mNoWrap,
        lNoWrap = _ref.lNoWrap,
        gutter = _ref.gutter,
        children = _ref.children;

    var columnClassNames = (0, _classnames3.default)('u-grid', className, (_classnames = {
        'u-grid--noWrap': noWrap,
        'u-grid--noWrap@s': sNoWrap,
        'u-grid--noWrap@m': mNoWrap,
        'u-grid--noWrap@l': lNoWrap
    }, _defineProperty(_classnames, 'u-grid--align' + (0, _capitalize2.default)(align), align), _defineProperty(_classnames, 'u-grid--gutter' + (0, _capitalize2.default)(gutter), gutter), _classnames));
    return _react2.default.createElement("div", { className: columnClassNames }, children);
};
var ALIGN_VALS = ['center', 'right', 'top', 'middle', 'bottom', 'stretch'];
var GUTTER_VALS = ['collapse', 'small', 'large'];
Grid.propTypes = {
    align: _propTypes2.default.oneOf(ALIGN_VALS).isRequired,
    gutter: _propTypes2.default.oneOf(GUTTER_VALS).isRequired,
    noWrap: _propTypes2.default.bool.isRequired,
    sNoWrap: _propTypes2.default.bool.isRequired,
    mNoWrap: _propTypes2.default.bool.isRequired,
    lNoWrap: _propTypes2.default.bool.isRequired,
    children: _propTypes2.default.node.isRequired,
    className: _propTypes2.default.string.isRequired
};
exports.default = Grid;
//# sourceMappingURL=Grid.js.map